var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action-icon",attrs:{"href":"javascript: void(0);"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('i',{staticClass:"fe-more-vertical icon-blue"})])
}
var staticRenderFns = []

export { render, staticRenderFns }